import { useBoolean } from '../useBoolean';
import { useCounter } from '../useCounter';
import { useInterval } from '../useInterval';
function useCountdown({ seconds, interval, isIncrement, }) {
    const { count, increment, decrement, reset: resetCounter, } = useCounter(seconds);
    const { value: running, setTrue: start, setFalse: stop } = useBoolean(false);
    const reset = () => {
        stop();
        resetCounter();
    };
    useInterval(isIncrement ? increment : decrement, running ? interval : null);
    return [count, { start, stop, reset }];
}
export default useCountdown;
//# sourceMappingURL=useCountdown.js.map